export enum CurrencyConversionStyles {
  CONTAINER = 'currency-conversion-container',
  MERCHANT_CURRENCY_ID = 'merchant-currency',
  CARD_CURRENCY_ID = 'card-currency'
}